import { useTranslation } from 'react-i18next'
import { useLocation, useParams } from 'react-router'
import { Head } from '#/components/head'
import { Button } from '#/components/ui/button'
import { Separator } from '#/components/ui/separator'
import { Heading, Text } from '#/components/ui/typography'


export default function KeycardLoading() {
  const { t } = useTranslation([ 'keycards' ])
  const params = useParams() as { keycardId: string }
  const { state } = useLocation()

  // Display name might be available from nav state
  const keycardName = state?.name ?? params.keycardId

  return (
    <div className="flex grow flex-col gap-4 items-start">

      <Head title={keycardName} />

      <div className="flex w-full items-end justify-between gap-4">
        <Heading>{keycardName}</Heading>
        <Button className="invisible" />
      </div>

      <Separator />

      <Text>{t('view_keycard.loading')}</Text>

    </div>
  )
}
